import React from "react";

function Skills() {
  const skillCategories = [
    {
      title: "Programming Languages",
      skills: ["Python", "JavaScript", "TypeScript", "Java", "C++"],
    },
    {
      title: "Frontend",
      skills: [
        "React",
        "Next.js",
        "React Native",
        "HTML5",
        "CSS3",
        "Bootstrap",
        "Tailwind CSS",
        "Material UI",
        "Three.js",
        "Recharts",
      ],
    },
    {
      title: "Backend & APIs",
      skills: [
        "Django",
        "Django REST Framework",
        "Node.js",
        "Express.js",
        "REST APIs",
        "Django Channels",
        "WebSockets",
        "JWT Authentication",
        "API Key Authentication",
        "RBAC",
        "Multi-Tenant Architecture",
        "Async Processing",
        "Event-Driven Systems",
      ],
    },
    {
      title: "AI / GenAI / Agentic AI",
      skills: [
        "Large Language Models",
        "Azure OpenAI",
        "Semantic Kernel",
        "Agentic AI",
        "Multi-Agent Workflows",
        "AI Orchestration",
        "Google Gemini API",
        "Vertex AI",
        "Hugging Face",
        "Ollama",
        "Prompt Engineering",
        "Root Cause Analysis",
      ],
    },
    {
      title: "Machine Learning / Data",
      skills: [
        "PyTorch",
        "TensorFlow",
        "Keras",
        "Scikit-learn",
        "NumPy",
        "Pandas",
        "OpenCV",
      ],
    },
    {
      title: "Cloud / DevOps / Tools",
      skills: [
        "Azure App Service",
        "Azure Blob Storage",
        "Azure SQL",
        "Azure AI Foundry",
        "Google Cloud Platform",
        "Google Cloud Run",
        "Google Cloud Storage",
        "Docker",
        "Celery",
        "Celery Beat",
        "Redis",
        "Render",
        "Vercel",
        "AWS",
        "Git",
        "GitHub",
      ],
    },
    {
      title: "Databases",
      skills: ["PostgreSQL", "MySQL", "MongoDB", "SQLite"],
    },
    {
      title: "Other Technologies",
      skills: ["XML", "XSL", "Axios", "CORS"],
    },
  ];

  return (
    <div className="skills-section aboutMe my-2">
      <div className="left my-4">
        <h1>TECHNICAL SKILLS</h1>
      </div>

      <div className="skills-grid">
        {skillCategories.map((category, index) => (
          <div className="skills-card" key={index}>
            <h3 className="skills-card-title">{category.title}</h3>

            <div className="skills-chip-wrap">
              {category.skills.map((skill, idx) => (
                <span className="skills-chip" key={idx}>
                  {skill}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Skills;